/* ==========================================================================
   HP LAB — result-engine.js
   Toma el resultado ya calculado (de diagnosis-engine) y arma el HTML del
   panel de resultado. Esta es la única pieza que "sabe" de HTML dentro
   del motor — separada del cálculo puro a propósito.
   ========================================================================== */
window.HPLab = window.HPLab || {};

HPLab.ResultEngine = {
  render: function (diagnosisResult, containerEl, iconHtml) {
    if (!containerEl) return;

    if (!diagnosisResult || !diagnosisResult.title) {
      containerEl.innerHTML = '<p style="text-align:center;color:var(--hp-ink-50);">No se pudo determinar un diagnóstico con las respuestas entregadas.</p>';
      return;
    }

    var confidence = Number(diagnosisResult.confidence);
    if (isNaN(confidence)) confidence = 0;

    var confidenceLabel = confidence >= 85
      ? "CONFIANZA ESTIMADA · ALTA"
      : confidence >= 65
        ? "CONFIANZA ESTIMADA · MEDIA"
        : "CONFIANZA ESTIMADA · BÁSICA";

    var secondary = Array.isArray(diagnosisResult.secondary) ? diagnosisResult.secondary : [];
    var causesHtml = secondary.map(function (c) {
      var title = (c && c.title) || "";
      var percent = (c && c.percent) || 0;
      return '<div class="hp-diagnosis-cause-row"><span>' + title + "</span><b>" + percent + "%</b></div>";
    }).join("");

    if (!causesHtml) {
      causesHtml = '<div class="hp-diagnosis-cause-row"><span>No existen otras hipótesis con evidencia suficiente según las respuestas ingresadas.</span></div>';
    }

    var title = diagnosisResult.title || "";
    var explanation = diagnosisResult.explanation || "";
    var iconBadge = iconHtml ? '<span class="hp-diagnosis-name__icon">' + iconHtml + "</span>" : "";

    containerEl.innerHTML =
      '<div class="hp-diagnosis-card__main">' +
        '<div class="hp-confidence-ring" style="--pct:' + confidence + ';">' +
          '<span class="hp-confidence-ring__pct">' + confidence + "%</span>" +
        "</div>" +
        '<div class="hp-diagnosis-card__text">' +
          '<div class="hp-diagnosis-confidence">' + confidenceLabel + "</div>" +
          '<div class="hp-diagnosis-name">' + iconBadge + title + "</div>" +
          '<div class="hp-diagnosis-text">' + explanation + "</div>" +
        "</div>" +
      "</div>" +
      '<p style="font-size:11px;color:var(--hp-ink-50);margin-top:16px;line-height:1.5;">' +
        "Este porcentaje representa una confianza estimada por HP LAB AI según tus respuestas, no una probabilidad estadística real." +
      "</p>" +
      '<div class="hp-diagnosis-causes"><div class="hp-diagnosis-causes__title">Otras posibilidades consideradas</div>' + causesHtml + "</div>";
  },

  /* Pinta la lista "Siguiente paso recomendado" desde diagnosisResult.recommendations
     (viene del propio hp-data-diagnosis.json) — nunca texto fijo en Liquid. */
  renderNextSteps: function (diagnosisResult, listEl) {
    if (!listEl) return;
    var recs = Array.isArray(diagnosisResult && diagnosisResult.recommendations) ? diagnosisResult.recommendations : [];
    var checkSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 5 5L19 7"/></svg>';

    if (!recs.length) {
      listEl.innerHTML = "<li>" + checkSvg + "Solicitar revisión técnica para confirmar el diagnóstico.</li>";
      return;
    }

    listEl.innerHTML = recs.map(function (r) {
      return "<li>" + checkSvg + r + "</li>";
    }).join("");
  }
};
